<template>
    <table class="table table-hover table-bordered table-sm mt-1 border">
        <thead>
            <tr>
                <th scope="col">Nombre</th>
                <th scope="col">Hotel</th>
                <th scope="col">Recogida</th>
                <th scope="col">Punto recogida</th>
                <th scope="col">Zona</th>
                <th scope="col">Hora recogida</th>
                <th scope="col">Orden</th>
                <th scope="col">Id externo parada</th>
                <th scope="col">Configurar</th>
            </tr>
        </thead>
        <!-- <draggable tag="tbody" v-model="rows"  @end="onEndDrag">   -->
        <tbody>
            <admin-stops-schedules-table-row :activity_group="activity_group" :item="row" v-for="row in rows" :key="row.id" />
        </tbody>
        <!-- </draggable> -->
    </table>
</template>

<script>
/* eslint-disable */
import draggable from "vuedraggable"
import AdminStopsSchedulesTableRow from './AdminStopsSchedulesTableRow'

export default {
    components: {
        draggable,
        AdminStopsSchedulesTableRow,
    },
    props: {
        rows: {
            type: Array,
            required: true,
        },
        activity_group: {
            type: Object || undefined,
            required: false,
        }
    },
    methods: {
        async onEndDrag(event) {
            await this.$store.dispatch('stops/reorderStopScheduleOrder', {
                activity_group_id: this.activity_group.id,
                oldIdx: event.oldIndex,
                newIdx: event.newIndex,
            })
            const data2 = {
                'activity_group_id': this.activity_group.id,
            }
            await this.$store.dispatch("stops/loadStopsAdmin", data2)
            this.$notify({
                group: "foo",
                title: "Parada reordenada",
                text: "Se ha reordenado la parada seleccionada",
                type: "success",
            });
            
        }
    }
}
</script>